import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useState, useCallback } from 'react';
import Swal from 'sweetalert2';
import { getSchemaForStep } from '../schemas/validationSchemas';
import { DEFAULT_FORM_VALUES, VALIDATION_MESSAGES, TOTAL_STEPS } from '../constants/formConstants';

export const useFormValidation = () => {
  const [currentStep, setCurrentStep] = useState(1);

  const form = useForm({
    defaultValues: DEFAULT_FORM_VALUES,
    resolver: yupResolver(getSchemaForStep(currentStep)),
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    getValues,
    watch,
    reset,
    trigger,
  } = form;

  const updateStepValidation = useCallback((step) => {
    // Instead of directly accessing private properties, we recreate the form with new resolver
    // This is a safer approach than accessing form._options.resolver
    const newResolver = yupResolver(getSchemaForStep(step));
    if (form._formOptions) {
      form._formOptions.resolver = newResolver;
    }
  }, [form]);

  const nextStep = useCallback(async () => {
    console.log('🔎 Validando etapa', currentStep);
    
    // Obter valores atuais do formulário
    const currentValues = getValues();
    console.log('📋 Valores do formulário:', currentValues);
    
    // Obter erros atuais
    console.log('⚠️ Erros atuais:', errors);
    
    const isValid = await trigger();
    
    console.log('✅ Validação resultado:', isValid);
    
    if (isValid) {
      if (currentStep < TOTAL_STEPS) {
        const newStep = currentStep + 1;
        console.log('🚀 Avançando para etapa', newStep);
        setCurrentStep(newStep);
        updateStepValidation(newStep);
      }
    } else {
      console.log('🚫 Validação falhou. Erros após trigger:', errors);
      
      Swal.fire({
        icon: 'error',
        title: 'Campos obrigatórios',
        text: VALIDATION_MESSAGES.REQUIRED_FIELDS,
      });
    }
  }, [currentStep, trigger, updateStepValidation, getValues, errors]);

  const prevStep = useCallback(() => {
    if (currentStep > 1) {
      const newStep = currentStep - 1;
      setCurrentStep(newStep);
      updateStepValidation(newStep);
    }
  }, [currentStep, updateStepValidation]);

  const goToStep = useCallback((step) => {
    if (step >= 1 && step <= TOTAL_STEPS) {
      setCurrentStep(step);
      updateStepValidation(step);
    }
  }, [updateStepValidation]);

  // Function for direct step setting (used by draft loading)
  const setCurrentStepDirect = useCallback((step) => {
    console.log('🎯 Setting step directly:', step);
    setCurrentStep(step);
    updateStepValidation(step);
  }, [updateStepValidation]);

  return {
    currentStep,
    setCurrentStep: goToStep,
    setCurrentStepDirect, // For internal use like draft loading
    form,
    register,
    handleSubmit,
    errors,
    control,
    setValue,
    getValues,
    watch,
    reset,
    trigger,
    nextStep,
    prevStep,
  };
};